import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import {
    Button,
    Card,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
} from "reactstrap"
import Flatpickr from "react-flatpickr";
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { exportDataExcel } from "components/Common/ExportData"
import { dateFormat, dateTimeFormat, dateTimeFormatIOS } from "pages/Common"
import EmployeeAttendanceLogTable from "./EmployeeAttendanceLogTable"

function EmployeeAttendanceLog() {
    document.title = `Employee Attendance Log | Raja Rani Couture`
    let { pathname } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()
    // useStates
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [userFilter, setUserFilter] = useState(0)
    const [users, setUsers] = useState([])
    const [dateFilter, setDateFilter] = useState([new Date(), new Date()])
    const [dateDisble, setdateDisble] = useState(true)
    const [totalRecords, setTotalRecords] = useState(0)
    const [totalHours, setTotalHours] = useState('0:00')
    const [statusFilter, setStatusFilter] = useState(0)
    const [addAttendanceLogModal, setAddAttendanceLogModal] = useState(false)
    const [userId, setUserId] = useState(0)
    const [punchDateTime, setPunchDateTime] = useState(new Date())
    const [isAddPunchtime, setIsAddPunchTime] = useState(false);

    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    useEffect(() => {
        getApi('Attendance/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])

    // user list api
    const attendanceLogApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Attendance/emp-attendance-list", {
            fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                dateFilter[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                dateFilter[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            AttendanceUserId: (JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? parseInt(userFilter) : JSON.parse(localStorage?.getItem("authUser")).AttendanceUserId,
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "asc",
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data?.EmpAttendanceLogList)
                setTotalRecords(data?.TotalRecords)
                setTotalHours(data?.TotalHours || '0:00')
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // user list api useEffect
    useEffect(() => {
        if (dateFilter[1] != undefined) {
            attendanceLogApi()
        }
    }, [searchText, displayStart, rowsPerPage, userFilter, dateFilter, dateDisble, statusFilter])

    const attendanceLogToggle = () => {
        setAddAttendanceLogModal(!addAttendanceLogModal)
    }

    const handleAddAttendanceLog = (userId, PunchInDateTime) => {
        setUserId(userId)
        setPunchDateTime(PunchInDateTime)
        attendanceLogToggle()
    }

    useEffect(() => {
        if (!addAttendanceLogModal) {
            setIsAddPunchTime(false)
        }
    }, [addAttendanceLogModal])


    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Name",
                Header: () => (
                    <div
                        style={{
                            fontSize: "16px"
                        }}
                    >
                        Name
                    </div>
                ),
                accessor: "Name",
                Cell: ({ row }) => (
                    <p className=" mb-0"
                        style={{
                            fontSize: "17px",
                            fontWeight: "bold"
                        }}>
                        {row.original?.Name == ""
                            ? "N/A"
                            : row.original?.Name}
                    </p>
                ),
            },
            {
                Header: "PunchIn Date-Time",
                Header: () => (
                    <div
                        style={{
                            fontSize: "16px"
                        }}
                    >
                        PunchIn Date-Time
                    </div>
                ),
                accessor: "PunchInDateTime",
                width: "15%",
                Cell: ({ row }) => (
                    <p className=" mb-0"
                        style={{
                            fontSize: "15px",
                        }}>
                        {row.original?.PunchInDateTime == "0001-01-01T00:00:00"
                            ? "N/A"
                            : dateTimeFormat(row.original?.PunchInDateTime, "dd-MM-yyyy HH:mm tt")}
                    </p>
                ),
            },
            {
                Header: "PunchOut Date-Time",
                Header: () => (
                    <div
                        style={{
                            fontSize: "16px"
                        }}
                    >
                        PunchOut Date-Time
                    </div>
                ),
                accessor: "PunchOutDateTime",
                width: "15%",
                Cell: ({ row }) => (
                    <p className=" mb-0"
                        style={{
                            fontSize: "15px",
                        }}>
                        {row.original?.PunchOutDateTime
                            ? dateTimeFormat(row.original?.PunchOutDateTime, "dd-MM-yyyy HH:mm tt")
                            :
                            <>
                                {(JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ?
                                    <div title="Add Attendance Log" style={{ cursor: "pointer" }}
                                        onClick={() => {
                                            setIsAddPunchTime(true);
                                            handleAddAttendanceLog(
                                                row.original?.AttendanceUserId,
                                                new Date(row.original?.PunchInDateTime)
                                            );
                                        }}
                                    >
                                        N/A
                                    </div>
                                    :
                                    <div>
                                        N/A
                                    </div>
                                }
                            </>
                        }
                    </p>
                ),
            },
            {
                Header: "Hours",
                Header: () => (
                    <div
                        style={{
                            fontSize: "16px"
                        }}
                    >
                        Hours
                    </div>
                ),
                accessor: "TotalTime",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0"
                        style={{
                            fontSize: "15px",
                        }}>
                        {row.original?.TotalTime == ""
                            ? "N/A"
                            : row.original?.TotalTime}
                    </p>
                ),
            },
        ],
        [tableData]
    )

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Name", "PunchIn Date-Time", "PunchOut Date-Time", "Hours"];
            const mainTitle = "Attendance Log";
            const widthObj = [{
                Key: "A",
                Value: 10,
            },
            {
                Key: "B",
                Value: 19,
            },
            {
                Key: "C",
                Value: 19,
            },
            {
                Key: "D",
                Value: 19,
            },
            {
                Key: "E",
                Value: 19,
            },
            {
                Key: "F",
                Value: 19,
            },
            {
                Key: "G",
                Value: 19,
            },
            {
                Key: "H",
                Value: 19,
            },
            {
                Key: "I",
                Value: 19,
            },
            {
                Key: "J",
                Value: 19,
            },
            ]
            const extention = "Attendance_Log.xlsx"
            let excelSheetData = []

            postApi("Attendance/emp-attendance-list", {
                fromDate: !dateDisble ? null : dateFilter[0] ? dateFormat(
                    dateFilter[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : dateFilter[1] ? dateFormat(
                    dateFilter[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                AttendanceUserId: (JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") ? parseInt(userFilter) : JSON.parse(localStorage?.getItem("authUser")).AttendanceUserId,
                displayStart: displayStart,
                pageSize: 10000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "asc",
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.EmpAttendanceLogList.length; index++) {
                        let dataObj = {
                            Name: data?.EmpAttendanceLogList[index].Name,
                            PunchInDateTime: data?.EmpAttendanceLogList[index].PunchInDateTime == null
                                ? "N/A"
                                : dateTimeFormat(data?.EmpAttendanceLogList[index].PunchInDateTime, "dd-MM-yyyy HH:mm tt"),
                            PunchOutDateTime: data?.EmpAttendanceLogList[index].PunchOutDateTime == null
                                ? "N/A"
                                : dateTimeFormat(data?.EmpAttendanceLogList[index].PunchOutDateTime, "dd-MM-yyyy HH:mm tt"),
                            TotalTime: data?.EmpAttendanceLogList[index].TotalTime,
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    setIsLoading(false)
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
                setIsLoading(false)
                setScreenLoad(false)
            })

            setIsLoading(false)
        }
    }

    const handleSubmit = () => {
        if (userId > 0) {
            setLoading(true)
            postApi("Attendance/add-attendance-log", {
                UserId: String(userId),
                PunchDateTime: dateTimeFormatIOS(punchDateTime),
            }).then(({ data, status }) => {
                setLoading(false)
                if (status === 200) {
                    attendanceLogToggle()
                    attendanceLogApi()
                    toast.success("Successfully Added",
                        {
                            style: {
                                fontSize: "15px"
                            }
                        });
                } else {
                    toast.error(data,
                        {
                            style: {
                                fontSize: "15px"
                            }
                        });
                }
                setLoading(false);
                setUserId(0)
                setPunchDateTime(new Date())
                attendanceLogToggle()
            });
        } else {
            toast.error("Please select employee",
                {
                    style: {
                        fontSize: "15px"
                    }
                });
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <EmployeeAttendanceLogTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isAddUserList={true}
                            customPageSize={10}
                            className="custom-header-css"
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            TotalHours={totalHours}
                            pagePerSize={pagePerSize}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                            users={users}
                            userFilter={userFilter}
                            setUserFilter={setUserFilter}
                            setdateDisble={setdateDisble}
                            dateDisble={dateDisble}
                            writeDataToExcel={writeDataToExcel}
                            statusFilter={statusFilter}
                            setStatusFilter={setStatusFilter}
                            handleAddAttendanceLog={handleAddAttendanceLog}
                        />


                        <Modal isOpen={addAttendanceLogModal} toggle={attendanceLogToggle} centered={true} size="defualt" style={{ width: "350px" }}>
                            <div className="modal-content">
                                <ModalHeader className="text-centre" toggle={attendanceLogToggle} tag="h5">
                                    <span> {"Add Attendance Log"} </span>
                                </ModalHeader>
                                <ModalBody>
                                    <React.Fragment>
                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                return false;
                                            }}
                                        >
                                            {(JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") &&
                                                <Row className="mb-3">
                                                    <Col md={12}>
                                                        <Label for="userId" className="form-label">Employee</Label>
                                                        <Input
                                                            type="select"
                                                            id="validationCustom01"
                                                            className="form-control-sm"
                                                            name="user"
                                                            bsSize="sm"
                                                            onChange={e => {
                                                                setUserId(e.target.value)
                                                            }}
                                                            value={userId}
                                                        >
                                                            <option value={0}>Select Employee</option>
                                                            {users.map((item, index) => {
                                                                return (
                                                                    <option key={index} value={item.Key}>
                                                                        {item.Value}
                                                                    </option>
                                                                )
                                                            })}
                                                        </Input>
                                                    </Col>
                                                </Row>
                                            }
                                            <Row>
                                                <Col md={12}>
                                                    <FormGroup className="mb-2">
                                                        <Label
                                                            htmlFor="validationCustom03"
                                                            className="required"
                                                        >
                                                            Punching Date Time
                                                        </Label>
                                                        {isAddPunchtime ?
                                                            <div className="d-flex date-after" >
                                                                <Flatpickr
                                                                    className="form-control d-block flatpicker-date"
                                                                    placeholder="dd-MM-yyyy"
                                                                    options={{
                                                                        enableTime: true,
                                                                        noCalendar: true,
                                                                        dateFormat: "H:i",
                                                                        time_24hr: true,
                                                                        disableMobile: true,
                                                                    }}
                                                                    value={punchDateTime}
                                                                    onChange={(selectedDates) => {
                                                                        const selectedTime = selectedDates[0];
                                                                        if (selectedTime) {
                                                                            const updatedDate = new Date(punchDateTime);
                                                                            updatedDate.setHours(selectedTime.getHours());
                                                                            updatedDate.setMinutes(selectedTime.getMinutes());
                                                                            setPunchDateTime(updatedDate);
                                                                        }
                                                                    }}
                                                                />

                                                            </div>
                                                            :
                                                            <div className="d-flex date-after" >
                                                                <Flatpickr
                                                                    className="form-control d-block flatpicker-date"
                                                                    placeholder="dd-MM-yyyy"
                                                                    options={{
                                                                        enableTime: true,
                                                                        dateFormat: "d-m-Y H:i",   // ✅ 24-hour format
                                                                        time_24hr: true,           // ✅ ensures 24hr mode
                                                                        disableMobile: true
                                                                    }}
                                                                    value={punchDateTime}
                                                                    onChange={(e) => { setPunchDateTime(e) }}
                                                                />

                                                            </div>
                                                        }
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <div className="text-end">
                                                {loading ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary btn-sm"
                                                        color="secondary"
                                                    >
                                                        <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                        Loading
                                                    </button>
                                                ) : (
                                                    <Button
                                                        user="primary"
                                                        className="btn btn-primary btn-sm "
                                                        type="button"
                                                        color="primary"
                                                        onClick={() => handleSubmit()}
                                                    >
                                                        Submit
                                                    </Button>
                                                )}
                                            </div>
                                        </Form>
                                    </React.Fragment >
                                </ModalBody>
                            </div>
                        </Modal >

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
EmployeeAttendanceLog.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default EmployeeAttendanceLog
